import { Component, Input } from '@angular/core';

@Component({
    selector: 'vertical-container',
    template: `
    <div [ngStyle]="style">
        <ng-content></ng-content>
    </div>
    `,
})
export class VerticalContainer {
    @Input() public flexProps: any = {};
    private baseStyle: any = {
        'display': 'flex',
        'flex-direction': 'column',
        // 'align-items': 'flex-start',
        // 'gap': '8px',
    };

    public get style() {
        return {
            ...this.baseStyle,
            ...this.flexProps,
        };
    }
}
